import type { TaskId } from '../tasks/constants.tsx';

export const QUICKSTART_UI_STATUS_NOT_LOADED = Symbol('NOT_LOADED');
export const QUICKSTART_UI_STATUS_OPEN = Symbol('OPEN');
export const QUICKSTART_UI_STATUS_MINIMIZED = Symbol('MINIMIZED');
export const QUICKSTART_UI_STATUS_DISMISSED = Symbol('DISMISSED');

export const PACKAGE_NAME = 'jiraPolarisComponentQuickstart';
export const PACKAGE_TEAM_NAME = 'jpd-juno';

export const QUICKSTART_PANEL_ID = 'jpd-quickstart';
export const QUICKSTART_PANEL_WIDTH = 365;
export const QUICKSTART_PANEL_VISIBILITY_STATE_KEY = 'polaris.quickstart-panel-visibility-state';
export const QUICKSTART_PANEL_OPEN_TASK_ID_STATE_KEY = 'polaris.quickstart-open-task-id';

export const taskIdToStateKey = {
	'explore-the-basics': 'polaris.quickstart-task-completed.explore-the-basics',
	'create-ideas': 'polaris.quickstart-task-completed.create-ideas',
	'prioritize-and-plan': 'polaris.quickstart-task-completed.prioritize-and-plan',
	'create-a-view': 'polaris.quickstart-task-completed.create-a-view',
	'share-and-collaborate': 'polaris.quickstart-task-completed.share-and-collaborate',
	'link-work-items': 'polaris.quickstart-task-completed.link-work-items',
} as const satisfies Record<TaskId, string>;

type StateKey = (typeof taskIdToStateKey)[TaskId];

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const stateKeyToTaskId = Object.fromEntries(
	Object.entries(taskIdToStateKey).map(([taskId, stateKey]) => [stateKey, taskId]),
) as Record<StateKey, TaskId>;

export type QuickstartUiStatus =
	| typeof QUICKSTART_UI_STATUS_NOT_LOADED
	| typeof QUICKSTART_UI_STATUS_OPEN
	| typeof QUICKSTART_UI_STATUS_MINIMIZED
	| typeof QUICKSTART_UI_STATUS_DISMISSED;

export const DEFAULT_QUICKSTART_UI_STATUS: QuickstartUiStatus = QUICKSTART_UI_STATUS_MINIMIZED;
